export const navigation = {
	label: {
		blueprintViewMode: 'Blueprint View',
		panelMode: 'Panel View',
		inlineMode: 'Inline View',
		overheadMode: 'Overhead View',
		manufacturingMode: 'Manufacturing View',
		skuOverheadMode: 'SKU View'
	},
	tooltip: {
		blueprintViewMode: 'Click here to toggle Blueprint View',
		disabledNotSupportCurrentView: 'Manufacturing view is not supported in the current view',
		manufacturingMode: 'Click here to toggle Manufacturing view',
		panelMode: 'Click here to switch to Panel Mode',
		inlineMode: 'Click here to switch to Inline Mode',
		overheadMode: 'Click here to toggle Overhead view',
		displayModeDesignerOnly: 'Only available in Designer Mode',
		skuOverheadMode: 'Click here to toggle SKU Overhead view'
	},
	message: {
	}
};
